/* import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosInstance, isAxiosError } from 'axios';
import { RejectValue } from './rest-shared-types';

export const fetchData = <ResponseType, RequestType>(
  url: string,
  apiClient: AxiosInstance,
  method: 'get' | 'post' = 'post',
  typePrefix?: string
) => {
  const chunkName =
    typePrefix || `${method.toUpperCase()}_${url.replace(/\//g, '_')}`;

  return createAsyncThunk<
    ResponseType,
    RequestType,
    { rejectValue: RejectValue }
  >(chunkName, async (data, thunkAPI) => {
    try {
      let res;
      if (method === 'get') {
        res = await apiClient.get<ResponseType>(url, { params: data });
      } else {
        const isFormData = data instanceof FormData;
        res = await apiClient.post<ResponseType>(url, data, {
          headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {},
        });
      }
      return res.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({
          message: `${error.message} ${error.status}`,
          code: error.code,
        });
      }
      return thunkAPI.rejectWithValue({ message: 'Unexpected error' });
    }
  });
};

export default fetchData; */

import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosInstance, isAxiosError } from 'axios';
import { RejectValue } from './rest-shared-types';

export const fetchData = <ResponseType, RequestType>(
  url: string,
  apiClient: AxiosInstance,
  method: 'get' | 'post' = 'post',
  typePrefix?: string
) => {
  const chunkName =
    typePrefix || `${method.toUpperCase()}_${url.replace(/\//g, '_')}`;

  return createAsyncThunk<
    ResponseType,
    { data: RequestType; captchaToken?: string },
    { rejectValue: RejectValue }
  >(chunkName, async ({ data, captchaToken }, thunkAPI) => {
    try {
      const headers: Record<string, string> = {};

      // Добавляем капчу в заголовки, если она есть
      if (captchaToken) {
        headers['g-recaptcha-response'] = captchaToken;
      }

      let res;

      if (method === 'get') {
        res = await apiClient.get<ResponseType>(url, {
          params: data,
          headers,
        });
      } else {
        const isFormData = data instanceof FormData;
        res = await apiClient.post<ResponseType>(url, data, {
          headers: {
            ...headers, // Добавляем заголовки капчи
            ...(isFormData ? { 'Content-Type': 'multipart/form-data' } : {}),
          },
        });
      }

      return res.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({
          message: `${error.message} ${error.status} ${error.stack}`,
          code: error.code,
        });
      }
      return thunkAPI.rejectWithValue({ message: 'Unexpected error' });
    }
  });
};

export default fetchData;
